import styled from '@emotion/styled';

export const StyledColoredLine = styled.div<{
  color?: string;
  linearColor1?: string;
  linearColor2?: string;
  linearColor3?: string;
  borderTopColor?: string;
}>`
  width: 100%;
  height: 13px;
  background: ${({ color, linearColor1, linearColor2, linearColor3 }) =>
    color
      ? color
      : `linear-gradient(
    to right,
    ${linearColor1} 49%,
    ${linearColor2},
    ${linearColor3}
  )`};
  ${({ borderTopColor }) => `border-top: 1px solid ${borderTopColor}`}
`;
